import { useQuery } from '@tanstack/react-query';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { API_HANDLERS } from 'api/apiHandlers';
import { EmptyState, Spinner } from 'components';
import { PINNED_POST_PREVIEW_LIMIT, QUERIES } from 'constants/index';
import { PostListItem } from 'features/postsList';
import { Links } from 'settings';
import { InstanceType } from 'types';

import { ListW, PostCardsGrid, PostCardWrapper, SeeAllLink } from './styled';

export function PinnedPostPreview(): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const queryParams = {
    type: [InstanceType.document, InstanceType.news, InstanceType.polls],
    limit: PINNED_POST_PREVIEW_LIMIT,
    place: 'lastUpdated',
    pin: true,
  };

  const { data, isLoading } = useQuery(
    [QUERIES.LAST_UPDATED_DOCS],
    () => API_HANDLERS.POST.GET_LIST(queryParams),
    {
      cacheTime: 0,
    },
  );

  const documents = data?.data.data || [];

  return (
    <ListW>
      {isLoading ? (
        <Spinner size="2.5rem" />
      ) : documents.length > 0 ? (
        <PostCardsGrid>
          {documents.map((doc) => (
            <PostCardWrapper key={doc.id}>
              <PostListItem
                id={doc.id}
                title={doc.title}
                description={doc.description}
                attachments={doc.attachments}
                author={doc.author}
                comments_count={doc.comments_count}
                type={doc.type}
                meta={doc.meta}
                poll={doc.poll}
                published_at={doc.published_at}
                reactions_stats={doc.reactions_stats}
                categoriesList={[]}
                pin={doc.pin}
                isPreview={false}
                hideAttachments
              />
            </PostCardWrapper>
          ))}
          <SeeAllLink onClick={() => navigate(Links.we.pinnedPosts)}>
            {t('we.posts.list.showAllPinned')}
          </SeeAllLink>
        </PostCardsGrid>
      ) : (
        <EmptyState>{t('we.pinnedPosts.emptyState')}</EmptyState>
      )}
    </ListW>
  );
}
